/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Care Club API - ASP.NET 8 - DEVELOPMENT (Local)
 * The Care Club API is a comprehensive backend service developed using ASP.NET 8. It facilitates seamless data access and interaction for services requiring information from the Care Club system. This API is designed to provide secure, reliable, and efficient access to member and service data, ensuring that all dependent applications can operate smoothly.
 * OpenAPI spec version: v1
 */

/**
 * Payment type identifier.<p>Members:</p><ul><li><i>cheque</i> - Cheque.</li></ul><p>Members:</p><ul></ul>
 */
export type CCNewAPIDtoPaymentTypeIDEnum = typeof CCNewAPIDtoPaymentTypeIDEnum[keyof typeof CCNewAPIDtoPaymentTypeIDEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CCNewAPIDtoPaymentTypeIDEnum = {
  direct_debit: 'direct_debit',
  credit_card: 'credit_card',
  debit_card: 'debit_card',
  cheque: 'cheque',
  standing_order: 'standing_order',
} as const;
